import Wrapper from "../../../layout/Wrapper";
import VehicleReportSummary from "../../../screens/reports/vehicleReportSummary";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "vehicle Report Summary",
	description: "",
};

export default function ClameReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<VehicleReportSummary />
		</Wrapper>
	);
}